import { useEffect, useState } from "react"
import sortHelper from "~/utils/sortHelper"

const useSortTranslations = (data) => {
  const [sort, setSort] = useState({ name: "", direction: "" })
  const [sortedTranslations, setSortedTranslations] = useState([])

  useEffect(() => {
    setSortedTranslations(data.translations)
  }, [data.translations])

  useEffect(() => {
    if (data?.translations?.length > 0) {
      setSortedTranslations((prevTranslations) =>
        sortHelper([...prevTranslations], "string", sort.name, sort.direction),
      )
    }
  }, [sort])

  return { sort, setSort, sortedTranslations }
}

export default useSortTranslations
